module.exports = __webpack_public_path__ + "static/media/slogan_hero_light.cc8031d4.svg";